export const childState = {
  id: null,
  total: 0,
  status: {
    readyForReview: {
      total: 0,
      audio: [],
    },
    readyForRecording: {
      total: 0,
    },
  },
};

export const initialState = {
  loading: false,
  fetchData: false,
  totalReadyForRecording: 0,
  totalReadyForReview: 0,
  0: childState,
};
